module.exports = __webpack_public_path__ + "img/154.ed7d0f11.jpg";